export const VEHICLE_STATUS_ORDER = [
  "yet_to_be_placed",
  "placed",
  "dispatched",
  "reached",
  "unloaded",
  "paymentapproved",
  "paid",
];

export const VEHICLE_STATUS_META = {
  yet_to_be_placed: { label: "Yet to be placed", icon: "⏱", cssKey: "yetToBePlaced" },
  placed: { label: "Placed", icon: "📍", cssKey: "placed" },
  dispatched: { label: "Dispatched", icon: "🚚", cssKey: "dispatched" },
  reached: { label: "Reached", icon: "✓", cssKey: "reached" },
  unloaded: { label: "Unloaded", icon: "📦", cssKey: "unloaded" },
  paymentapproved: { label: "Payment approved", icon: "💳", cssKey: "paymentApproved" },
  paid: { label: "Paid", icon: "💰", cssKey: "paid" },
};
